import { Action, createReducer, on } from '@ngrx/store';
import {
  EntityState,
  EntityAdapter,
  createEntityAdapter,
} from '@ngrx/entity';

import { DetectionLabel } from '../../models/detection-label';
import * as DetectionLabelActions from './detection-label.actions';

export interface State extends EntityState<DetectionLabel> {}

export const adapter: EntityAdapter<DetectionLabel> =
  createEntityAdapter<DetectionLabel>({
    selectId: (label) => label.key,
  });

export const initialState: State =
  adapter.getInitialState();

const detectionLabelReducer = createReducer(
  initialState,
  on(
    DetectionLabelActions.loadDetectionLabelsSuccess,
    (state, { labels }) =>
      adapter.setAll(labels, state),
  ),
);

export function reducer(
  state: State | undefined,
  action: Action,
): State {
  return detectionLabelReducer(state, action);
}
